import { StoplightElementsEvent, StoplightElementsListener } from './listeners';

// Listen for the custom event and customize the panel
window.addEventListener(StoplightElementsListener.TryItPanelAdded, (e) => {
  const event = e as StoplightElementsEvent;
  if (event.detail?.node) {
    customizeTryItPanel(event.detail.node);
  }
});

const customizeTryItPanel = (node: Element) => {
  const container = node.parentElement!;
  const dialog = container.parentElement!;
  const mask = document.createElement('div');
  const closeButton = document.createElement('button');
  const fullscreenButton = document.createElement('button');

  dialog.classList.add('TryItPanel-dialog');
  container.classList.add('TryItPanel-container');
  mask.classList.add('TryItPanel-mask');
  closeButton.classList.add('TryItPanel-mask-close');
  fullscreenButton.classList.add('TryItPanel-fullscreen');

  fullscreenButton.onclick = () => dialog.classList.add('dialog-open');
  mask.onclick = () => dialog.classList.remove('dialog-open');
  closeButton.onclick = () => dialog.classList.remove('dialog-open');

  mask.appendChild(closeButton);
  dialog.appendChild(mask);

  fullscreenButton.appendChild(fullscreenSvg);
  container.appendChild(fullscreenButton);
};

const fullscreenSvg = (() => {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', '24');
  svg.setAttribute('height', '24');
  svg.setAttribute('fill', 'white');
  // Path is from OpenInFull from MUI
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', 'M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z');
  svg.appendChild(path);
  return svg;
})();
